module.exports = __webpack_public_path__ + "static/media/ic-cross.9c5c0321.svg";